import styled from 'styled-components'
import { theme } from './styles'

export const Scope = styled.div`
  display: flow-root;
  min-height: 100vh;
  background:
    radial-gradient(120% 80% at 50% -10%, ${theme.cores.paperAlt} 0%, ${theme.cores.paper} 60%);
`

export const Shell = styled.main`
  max-width: 1120px;
  margin: 0 auto;
  padding: 0 24px;

  ${theme.mobile} {
    padding: 0 18px;
  }
`

export const Hero = styled.section`
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  gap: 24px;

  ${theme.mobile} {
    margin-top: 18px;
    gap: 16px;
  }
`

export const Message = styled.div`
  background: ${theme.cores.paperAlt};
  border: 1px solid ${theme.cores.border};
  border-radius: ${theme.raio.md};
  padding: 24px;
  color: ${theme.cores.inkDeep};
  font-size: 15px;
  max-width: 640px;
`

export const Spinner = styled.div`
  color: ${theme.cores.inkSoft};
  font-size: 14px;
  padding: 20px;
`
